import { ClickAwayListener, createStyles, FormGroup, FormHelperText, IconButton, InputLabel, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, makeStyles, Paper, TextField, Typography } from '@material-ui/core';
import { ConstantContent } from '@sensenet/client-core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useCallback, useEffect, useState } from 'react';
import { typeicons } from "../assets/icons.js";
import { renderIconDefault } from "./icon.js";
import { defaultLocalization } from "./localization.js";
const INPUT_PLACEHOLDER = 'Start typing to add another type';
const ITEM_HEIGHT = 48;
const useStyles = makeStyles(() => {
  return createStyles({
    inputContainer: {
      padding: '2px 4px',
      alignItems: 'center',
      boxShadow: 'none',
      position: 'relative'
    },
    input: {
      marginLeft: 8,
      flex: 1
    },
    button: {
      padding: 10
    },
    listContainer: {
      position: 'absolute',
      top: '40px',
      maxHeight: ITEM_HEIGHT * 2.5,
      overflow: 'auto',
      zIndex: 10
    },
    list: {},
    listItem: {
      margin: 0
    },
    remove: {
      marginLeft: '8px'
    },
    ddIsOpened: {
      display: 'block'
    },
    ddIsClosed: {
      display: 'none'
    }
  });
});
const compare = (a, b) => {
  if (a.Name < b.Name) {
    return -1;
  }
  if (a.Name > b.Name) {
    return 1;
  }
  return 0;
};

/**
 * Field control that represents an AllowedChildTypes field. Available values will be populated from the FieldSettings.
 */
export const AllowedChildTypes = props => {
  var _props$localization;
  const classes = useStyles(props);
  const localization = deepMerge(defaultLocalization.allowedChildTypes, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.allowedChildTypes);
  const [isOpened, setIsOpened] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [selected, setSelected] = useState([]);
  const [allowedTypesOnCTD, setAllowedTypesOnCTD] = useState([]);
  const [allCTDs, setAllCTDs] = useState([]);
  const [currentSelected, setCurrentSelected] = useState();
  const filteredList = allCTDs.filter(ctd => {
    var _ctd$DisplayName;
    return (_ctd$DisplayName = ctd.DisplayName) === null || _ctd$DisplayName === void 0 ? void 0 : _ctd$DisplayName.toLowerCase().includes(inputValue.toLowerCase());
  });
  const getTypes = useCallback((typeResults, allowedChildTypesFromCTD) => {
    if (props.actionName === 'new') {
      return allowedChildTypesFromCTD.d.results.length && allowedChildTypesFromCTD.d.results || [];
    }
    return typeResults.length ? typeResults : allowedChildTypesFromCTD.d.results;
  }, [props.actionName]);
  useEffect(() => {
    ;
    (async () => {
      try {
        if (!props.repository) {
          throw new Error('You must pass a repository to this control');
        }
        if (!props.content) {
          return;
        }
        const result = await props.repository.load({
          idOrPath: props.content.Path,
          oDataOptions: {
            select: ['EffectiveAllowedChildTypes'],
            expand: ['EffectiveAllowedChildTypes']
          }
        });
        const allowedChildTypesFromCTD = await props.repository.allowedChildTypes.getFromCTD(props.content.Path);
        const typeResults = result.d.EffectiveAllowedChildTypes;
        const types = getTypes(typeResults, allowedChildTypesFromCTD);
        setSelected(types);
        setAllowedTypesOnCTD(allowedChildTypesFromCTD.d.results);
      } catch (error) {
        console.error(error.message);
      }
    })();
  }, [props.actionName, props.content, props.repository, getTypes]);
  useEffect(() => {
    ;
    (async () => {
      try {
        if (!props.repository) {
          throw new Error('You must pass a repository to this control');
        }
        const result = await props.repository.executeAction({
          idOrPath: ConstantContent.PORTAL_ROOT.Id,
          name: 'GetAllContentTypes',
          method: 'GET',
          oDataOptions: {
            select: ['Name', 'DisplayName', 'Icon']
          }
        });
        setAllCTDs(result.d.results.sort(compare));
      } catch (error) {
        console.error(error.message);
      }
    })();
  }, [props.repository]);
  const handleRemove = item => {
    if (selected.length > 1) {
      var _props$fieldOnChange;
      const newSelected = selected.filter(i => item.Name !== i.Name);
      setSelected(newSelected);
      (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, newSelected.map(newItem => newItem.Name));
    } else {
      var _props$fieldOnChange2;
      const valuesOnCTD = allowedTypesOnCTD.map(allowedType => allowedType.Name);
      setSelected(allowedTypesOnCTD);
      (_props$fieldOnChange2 = props.fieldOnChange) === null || _props$fieldOnChange2 === void 0 ? void 0 : _props$fieldOnChange2.call(props, props.settings.Name, valuesOnCTD);
    }
  };
  const handleInputChange = e => {
    const term = e.target.value;
    setInputValue(term);
    if (term.length === 0) {
      setCurrentSelected(undefined);
    }
  };
  const handleClickAway = () => {
    setIsOpened(false);
  };
  const handleSelect = item => {
    setCurrentSelected(item);
    setInputValue(item.DisplayName || '');
    setIsOpened(false);
  };
  const handleOnClick = () => {
    setIsOpened(true);
  };
  const handleAddClick = () => {
    var _props$fieldOnChange3;
    const newSelection = currentSelected ? [...selected, currentSelected] : selected;
    setSelected(newSelection);
    (_props$fieldOnChange3 = props.fieldOnChange) === null || _props$fieldOnChange3 === void 0 ? void 0 : _props$fieldOnChange3.call(props, props.settings.Name, newSelection.map(item => item.Name));
    setCurrentSelected(undefined);
    setInputValue('');
  };
  const renderMenuItem = (item, select) => /*#__PURE__*/React.createElement(ListItem, {
    key: item.Id,
    value: item.Id,
    onClick: () => select(item)
  }, /*#__PURE__*/React.createElement(ListItemIcon, {
    style: {
      margin: 0
    }
  }, props.renderIcon ? props.renderIcon(item.Icon ? item.Icon.toLowerCase() : 'contenttype') : renderIconDefault(item.Icon && typeicons[item.Icon.toLowerCase()] ? typeicons[item.Icon.toLowerCase()] : typeicons.contenttype)), /*#__PURE__*/React.createElement(ListItemText, {
    primary: item.DisplayName
  }));
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(ClickAwayListener, {
        onClickAway: handleClickAway
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block',
          minWidth: '350px'
        }
      }, /*#__PURE__*/React.createElement(InputLabel, {
        shrink: true,
        htmlFor: props.settings.Name,
        required: props.settings.Compulsory
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(List, {
        dense: true,
        className: classes.list
      }, selected.map((item, index) => /*#__PURE__*/React.createElement(ListItem, {
        key: index,
        className: classes.listItem
      }, /*#__PURE__*/React.createElement(ListItemIcon, {
        style: {
          margin: 0
        }
      }, props.renderIcon ? props.renderIcon(item.Icon ? item.Icon.toLowerCase() : 'contenttype') : renderIconDefault(item.Icon && typeicons[item.Icon.toLowerCase()] ? typeicons[item.Icon.toLowerCase()] : typeicons.contenttype)), /*#__PURE__*/React.createElement(ListItemText, {
        primary: item.DisplayName
      }), /*#__PURE__*/React.createElement(ListItemSecondaryAction, {
        className: classes.remove
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "Remove",
        onClick: () => handleRemove(item)
      }, props.renderIcon ? props.renderIcon('delete') : renderIconDefault('delete')))))), /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(FormGroup, {
        row: true,
        className: classes.inputContainer
      }, /*#__PURE__*/React.createElement(TextField, {
        id: props.settings.Name,
        autoComplete: "off",
        type: "search",
        onClick: handleOnClick,
        onChange: handleInputChange,
        placeholder: INPUT_PLACEHOLDER,
        value: inputValue,
        className: classes.input
      }), /*#__PURE__*/React.createElement(IconButton, {
        color: "primary",
        className: classes.button,
        disabled: currentSelected && currentSelected.Name.length > 0 ? false : true,
        onClick: handleAddClick
      }, props.renderIcon ? props.renderIcon('add_circle') : renderIconDefault('add_circle'))), /*#__PURE__*/React.createElement(Paper, {
        className: `${classes.listContainer} ${isOpened ? classes.ddIsOpened : classes.ddIsClosed}`
      }, /*#__PURE__*/React.createElement(List, null, filteredList.length > 0 ? filteredList.map(item => renderMenuItem(item, handleSelect)) : /*#__PURE__*/React.createElement(ListItem, null, "No hits"))), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description))));
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), selected.length ? /*#__PURE__*/React.createElement(List, {
        dense: true
      }, selected.map((item, index) => /*#__PURE__*/React.createElement(ListItem, {
        key: index
      }, /*#__PURE__*/React.createElement(ListItemIcon, {
        style: {
          margin: 0
        }
      }, props.renderIcon ? props.renderIcon(item.Icon ? item.Icon.toLowerCase() : 'contenttype') : renderIconDefault(item.Icon && typeicons[item.Icon.toLowerCase()] ? typeicons[item.Icon.toLowerCase()] : typeicons.contenttype)), /*#__PURE__*/React.createElement(ListItemText, {
        primary: item.DisplayName
      })))) : /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true
      }, localization.noValue));
  }
};
//# sourceMappingURL=allowed-child-types.js.map